// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-3IQXm","pageItem":"index-pageItem-TRCSQ","scrollTips":"index-scrollTips-1e1Mn"};